import React from "react";

export default function Settings(props) {
  return <div className={`${props.class.container}`}>Settings</div>;
}
